<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-form ref="form">
          <v-container fluid>
            <v-tabs v-model="tab" @change="tabChanged()">
              <v-tab>{{$t('Import from Excel')}}</v-tab>
              <v-tab>{{$t('Import home quarantine from Excel')}}</v-tab>
              <v-tab-item :transition="false" :reverse-transition="false">
                <v-row>
                  <v-col cols="6" class="d-flex align-center">
                    <v-file-input
                      :label="$t('Excel file to be uploaded')"
                      prepend-icon="mdi-file-excel"
                      accept=".xls, .xlsx"
                      clearable
                      v-model="file"
                      :rules="[v=> (v && !!v.size) || this.$t('This field is required!')]"
                      v-bind:disabled="isLoading"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn
                      color="primary"
                      :loading="isLoading"
                      :disabled="isLoading"
                      @click="upload"
                    >{{$t('Upload')}}</v-btn>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn @click="downloadTemplate">{{$t('Download template')}}</v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false">
                <v-row>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-menu
                      v-model="datePickerMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dateFormatted"
                          :label="$t('Import data from date')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        :max="maxDate"
                        :min="minDate"
                        v-model="date"
                        no-title
                        @input="datePickerMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="6" class="d-flex align-center">
                    <v-file-input
                      :label="$t('Excel file to be uploaded')"
                      prepend-icon="mdi-file-excel"
                      accept=".xls, .xlsx"
                      clearable
                      v-model="file"
                      :rules="[v=> (v && !!v.size) || this.$t('This field is required!')]"
                      v-bind:disabled="isLoading"
                    ></v-file-input>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn
                      color="primary"
                      :loading="isLoading"
                      :disabled="isLoading"
                      @click="upload"
                    >{{$t('Upload')}}</v-btn>
                  </v-col>
                  <v-col cols="auto" class="d-flex align-center">
                    <v-btn @click="downloadTemplate">{{$t('Download template')}}</v-btn>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs>
            <v-row></v-row>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
    <v-row v-if="data.length">
      <v-col cols="12">
        <v-data-table :headers="headers" :options.sync="gridOptions" :items="data" item-key="id">
          <template v-slot:item.validity="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  v-model="item.validity"
                  v-show="item.validity"
                  :color="getValidityColor(item.validity)"
                  @click="editAlert(item.id)"
                >mdi-alert</v-icon>
              </template>
              <div v-html="item.validityMessage"></div>
            </v-tooltip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              </template>
              <span>{{$t('Update')}}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
              </template>
              <span>{{$t('Delete')}}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="12" class="d-flex justify-end align-baseline">
        <span
          class="body-2 mr-4"
        >{{invalidRowsCount > 0 ? `${$t('Number of invalid rows')}: ${invalidRowsCount}. ${$t("Please correct or delete the incorrect rows before saving.")}` : ''}}</span>

        <v-btn
          @click="bulkInsert"
          :disabled="invalidRowsCount > 0 || isUploading"
          :loading="isUploading"
          color="primary"
        >Összes adat mentése</v-btn>
      </v-col>
      <v-col cols="12" class="d-flex justify-end align-baseline">
        <span
          class="body-2 mr-4"
        >{{warningRowsCount > 0 ? `${$t('Number of rows with warning')}: ${warningRowsCount}. ${$t("Verify that you really want to save these rows.")}` : ''}}</span>
      </v-col>
    </v-row>

    <v-dialog ref="editDialog" persistent v-model="isEditing" scrollable max-width="1000px">
      <v-card>
        <v-card-title>{{$t('Update')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-if="isEditing" ref="editForm" lazy-validation v-model="editFormIsValid">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="$t('ID')"
                  v-model="editedItem.azon"
                  :rules="[this.rules.required]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field :label="$t('Age')" v-model.number="editedItem.age" type="number"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  :label="$t('Gender')"
                  :items="translatedGenders"
                  item-text="label"
                  item-value="value"
                  v-model="editedItem.gender"
                ></v-select>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  :label="$t('Mobile number')"
                  v-model="editedItem.phoneNumber"
                  :hint="$t('Format')+': +36201234567'"
                  :error-messages="phonenumberErrors"
                  :rules="[this.rules.phone]"
                  @keyup="formatPhoneNumber"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-select
                  :label="$t('Status')"
                  :items="statuses"
                  item-text="label"
                  item-value="value"
                  v-model="editedItem.status"
                  :rules="[this.rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('Beginning of status')"
                  v-model="editedItem.date"
                  prepend-icon="date_range"
                  :hint="$t('Format: 15/03/2020 8:10:20')"
                  :rules="[this.rules.required,this.rules.isDate]"
                  persistent-hint
                  @blur="formatDate(editedItem,'date')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="$t('Beginning of home quarantine')"
                  v-model="editedItem.homeQuarantineStart"
                  prepend-icon="date_range"
                  :hint="$t('Format: 15/03/2020 8:10:20')"
                  :rules="[this.rules.isDate]"
                  persistent-hint
                  @blur="formatDate(editedItem,'homeQuarantineStart')"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('End of home quarantine')"
                  v-model="editedItem.homeQuarantineEnd"
                  prepend-icon="date_range"
                  :hint="$t('Format: 15/03/2020 8:10:20')"
                  :rules="[this.rules.isDate]"
                  persistent-hint
                  @blur="formatDate(editedItem,'homeQuarantineEnd')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="editedItem.geocodedAddress"
                  :items="addressAutoCompleteEntries"
                  :loading="isAddressAutoCompleteLoading"
                  :search-input.sync="addressAutoCompleteSearch"
                  hide-no-data
                  hide-selected
                  :label="$t('Primary address')"
                  :rules="[this.rules.required]"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="$t('Remark')" v-model="editedItem.description"></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancel()">{{$t('Cancel')}}</v-btn>
          <v-btn @click="save()" color="primary">{{$t('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog ref="alertDialog" persistent v-model="isAlertEditing" scrollable max-width="1000px">
      <v-card>
        <v-card-title>{{$t('Manage warnings')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            v-if="isAlertEditing"
            ref="editAlertForm"
            lazy-validation
            v-model="editAlertFormIsValid"
          >
            <v-data-table :headers="alertHeaders" :items="duplicates" item-key="id">
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small class="mr-2" @click="resolveAlert(item)">mdi-check</v-icon>
                  </template>
                  <span>{{$t('Solved')}}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelAlert()">{{$t('Cancel')}}</v-btn>
          <v-btn @click="saveAlert()" color="primary">{{$t('Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "../services/ApiService";
import moment from "moment-mini";
import debounce from "lodash.debounce";
import { mapActions, mapState } from "vuex";
import { formatDate, getDateTimeFormat, getDates } from "../helpers/dateFormat";
import { phoneNumberFormatter, phoneRule } from "../helpers/patientDataChecker";

export default {
  name: "Import",

  data() {
    return {
      formatDate: formatDate,
      editedItem: {},
      editFormIsValid: true,
      isEditing: false,
      isLoading: false,
      isUploading: false,
      file: undefined,
      addressAutoCompleteSearch: "",
      isAddressAutoCompleteLoading: false,
      addressAutoCompleteEntries: [],
      phonenumberErrors: [],
      data: [],
      validityWarnings: [],
      isAlertEditing: false,
      editAlertFormIsValid: true,
      duplicates: [],
      removedDuplicates: [],
      editedAlert: undefined,
      gridOptions: {
        sortBy: ["validity"],
        sortDesc: [true]
      },
      rules: {
        required: value => !!value || this.$t("This field is required!"),
        isDate: value =>
          !value ||
          moment(value, getDateTimeFormat()).isValid() ||
          `${this.$t("The specified format is incorrect!")} ${this.$t('Format: 15/03/2020 8:10:20')}`,
        phone: phoneRule
      },
      statuses: [],
      genders: [
        { value: "", label: "" },
        { value: "male", label: "férfi" },
        { value: "female", label: "nő" }
      ],
      tab: undefined,
      datePickerMenu: false,
      date: undefined,
      minDate: undefined,
      maxDate: undefined,
      dateFormatted: ""
    };
  },

  watch: {
    addressAutoCompleteSearch(value) {
      if (!value) {
        return;
      }
      this.refreshLocations(value);
    },
    config(config) {
      if (config) {
        this.statuses = config.statuses;
      }
    },
    date() {
      this.dateFormatted = moment(this.date).format("YYYY.MM.DD");
    }
  },
  computed: {
    ...mapState({
      config: state => state.app.config
    }),

    translatedGenders() {
      return this.genders.map(x => ({ ...x, label: this.$t(x.value) }))
    },

    headers(){ return [
      {
        text: this.$t('Incorrect row'),
        align: "start",
        value: "validity",
        width: "110"
      },
      {
        text: this.$t("ID"),
        align: "start",
        value: "azon"
      },
      {
        text: this.$t("Age"),
        value: "age"
      },
      {
        text: this.$t("Gender"),
        value: "genderText"
      },
      { text: this.$t("Status"), value: "statusText" },
      { text: this.$t("Beginning of status"), value: "date" },
      { text: this.$t("Beginning of home quarantine"), value: "homeQuarantineStart" },
      { text: this.$t("End of home quarantine"), value: "homeQuarantineEnd" },
      { text: this.$t("Specified address"), value: "address" },
      { text: this.$t("Geocoded address"), value: "geocodedAddress" },
      { text: this.$t("Remark"), value: "description" },
      { text: this.$t("Mobile number"), value: "phoneNumber", width: "150" },
      { text: "", value: "actions", width: "80", sortable: false }
    ]},

    alertHeaders() {return [
      {
        text: this.$t("ID"),
        align: "start",
        value: "azon"
      },
      {
        text: this.$t("Age"),
        value: "age"
      },
      {
        text: this.$t("Gender"),
        value: "genderText"
      },
      { text: this.$t("Geocoded address"), value: "address" },
      { text: this.$t("Nature of duplication"), value: "typeText" },
      { text: "", value: "actions", width: "80", sortable: false }
    ]},

    invalidRowsCount() {
      return this.data.filter(x => x.validity === 2).length;
    },
    warningRowsCount() {
      return this.data.filter(x => x.validity === 1).length;
    }
  },

  async mounted() {
    if (this.config) {
      this.statuses = this.config.statuses;
    }
    const datesResult = getDates();

    this.minDate = datesResult.minDate;
    this.maxDate = datesResult.maxDate;

    await this.updateDate();
  },

  methods: {
    ...mapActions("alert", ["error", "success"]),

    genderText(value) {
      if (value === "male") {
        return this.$t("male");
      }
      if (value === "female") {
        return this.$t("female");
      }
      return "";
    },
    duplicationText(value) {
      if (value === "db") {
        return this.$t("database");
      }
      if (value === "own") {
        return this.$t("current upload");
      }
      return "";
    },

    tabChanged() {
      this.file = undefined;
      this.data = [];
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    editItem(item) {
      this.editedItem = { ...item };
      this.addressAutoCompleteSearch = this.editedItem.address;
      this.isEditing = true;
    },

    async deleteItem(item) {
      const answer = await this.$confirm(
        this.$t("Are you sure you want to delete the selected item?")
      );
      if (answer) {
        const connectedWarnings = this.validityWarnings.find(
          x => x.nr === item.id
        );
        if (connectedWarnings && connectedWarnings.duplicates) {
          this.updateConnectedDuplicates(item.id, connectedWarnings.duplicates);
        }
        this.data = this.data.filter(x => x.id !== item.id);
      }
    },

    cancel() {
      this.isEditing = false;
    },

    async save() {
      this.formatPhoneNumber();

      if (this.$refs.editForm.validate() && !this.phonenumberErrors.length) {
        const index = this.data.findIndex(x => x.id === this.editedItem.id);

        const statusText = this.statuses.find(
          x => x.value === this.editedItem.status
        ).label;
        const genderText = this.genderText(this.editedItem.gender);

        if (
          !this.editedItem.azon ||
          !this.editedItem.geocodedAddress ||
          !this.editedItem.status
        ) {
          this.editedItem.validity = 2;
          this.editedItem.validityMessage =
            `<b>${this.$t('Error')}!</b><br>${this.$t('ID, status and address are required!')}<br>` +
            this.editedItem.validityMessage;
        } else {
          this.editedItem.places = [
            { primary: true, address: this.editedItem.geocodedAddress }
          ];

          const { data: duplicates } = await api.duplicate(this.editedItem);

          this.upsertWarningDbDuplicates(this.editedItem.id, duplicates);

          this.upsertWarningDates(this.editedItem);

          this.editedItem.validityMessage = this.getWarningMessage(this.editedItem.id);
          this.editedItem.validity = this.editedItem.validityMessage ? 1 : 0;
        }

        this.data.splice(index, 1, {
          ...this.editedItem,
          statusText,
          genderText
        });
        this.isEditing = false;
      }
    },

    editAlert(id) {
      this.editedAlert = id;
      let w = this.validityWarnings.find(x => x.nr === id);
      if (!w || !w.duplicates) {
        return;
      }
      this.duplicates = w.duplicates.map(item => {
        item.genderText = this.genderText(item.gender);
        item.typeText = this.duplicationText(item.type);
        return item;
      });
      this.isAlertEditing = true;
    },

    resolveAlert(alert) {
      const index = this.duplicates.findIndex(x => x.id === alert.id);
      this.removedDuplicates.push(this.duplicates.splice(index, 1)[0]);
    },

    cancelAlert() {
      this.isAlertEditing = false;
    },

    saveAlert() {
      let w = this.validityWarnings.find(x => x.nr === this.editedAlert);
      w.duplicates = [...this.duplicates];
      if (!w.duplicates.length) {
        w.duplicates = undefined;
      }
      this.updateItemValidity(this.editedAlert);
      this.updateConnectedDuplicates(this.editedAlert, this.removedDuplicates);
      this.removedDuplicates = [];
      this.isAlertEditing = false;
    },

    refreshLocations: debounce(async function(value) {
      this.isAddressAutoCompleteLoading = true;
      try {
        const response = await api.locationSearch(value);
        const result = [];
        response.data.result.features.forEach(item => {
          result.push(item.properties.address);
        });
        this.addressAutoCompleteEntries = result;
      } catch (ex) {
        this.addressAutoCompleteEntries = [];
      } finally {
        this.isAddressAutoCompleteLoading = false;
      }
    }, 300),

    async formatPhoneNumber(event) {
      let data = await phoneNumberFormatter(
        event,
        this.editedItem.phoneNumber,
        this.phonenumberErrors
      );
      this.editedItem.phoneNumber =
        data && data.phoneNumber ? data.phoneNumber : "";
      this.phonenumberErrors =
        data && data.phonenumberErrors ? data.phonenumberErrors : [];
    },

    downloadTemplate() {
      if (this.tab === 1) {
        window.open((process.env.BASE_URL || "/") + "importhq.xlsx");
      } else {
        window.open((process.env.BASE_URL || "/") + "import.xlsx");
      }
    },

    async upload() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        let formData = new FormData();
        if (this.file) {
          formData.append("file", this.file);
          try {
            let params = { type: "default" };
            if (this.tab === 1) {
              params = { type: "hq", fromDate: this.date };
            }
            const response = await api.import(formData, params);

            if (response.data && response.data.error) {
              throw response.data.error;
            }

            if (response.data && response.data.warnings) {
              this.validityWarnings = response.data.warnings;
            }

            const dataItems = [];

            response.data.result.forEach((element, index) => {
              const warningMsg = this.getWarningMessage(index);
              const item = {
                id: index,
                azon: element.azon,
                age: element.age,
                gender: element.gender,
                genderText: this.genderText(element.gender),
                status: "",
                date: moment(element.status_start).format("YYYY.MM.DD"),
                address: element.address,
                geocodedAddress: "",
                description: element.description,
                phoneNumber: element.phoneNumber,
                places: element.places,
                homeQuarantineStart:
                  element.home_quarantine_start || element.home_quarantine_end
                    ? moment(element.home_quarantine_start).format("YYYY.MM.DD")
                    : null,
                homeQuarantineEnd: element.home_quarantine_end
                  ? moment(element.home_quarantine_end).format("YYYY.MM.DD")
                  : null,
                validity: warningMsg ? 1 : undefined,
                validityMessage: warningMsg
              };

              if (
                element.geocode &&
                element.geocode.properties &&
                element.geocode.properties.address
              ) {
                item.geocodedAddress = element.geocode.properties.address;
              }

              // find status by id or display text
              const status = this.statuses.find(
                x =>
                  x.value === element.status_value ||
                  x.label === element.status_value
              );

              if (status) {
                item.status = status.value;
                item.statusText = status.label;
              }

              if (!item.azon || !item.geocodedAddress || !item.status) {
                item.validity = 2;
                item.validityMessage =
                  `<b>${this.$t('Error')}!</b><br>${this.$t('ID, status and address are required!')}<br>` +
                  (item.validityMessage ? item.validityMessage : "");
              }

              dataItems.push(item);
            });

            this.data = [...dataItems];
          } catch (ex) {
            this.error(ex);
          } finally {
            this.isLoading = false;
          }
        }

        this.$refs.form.resetValidation();
      }
    },

    async bulkInsert() {
      this.isUploading = true;
      this.data.forEach(element => {
        element.statuses = [];
        element.statuses.push({
          status: element.status,
          date: moment(element.date, "YYYY.MM.DD HH:mm:ss").toISOString()
        });

        element.homeQuarantines = [];
        if (element.homeQuarantineStart) {
          element.homeQuarantines.push({
            timeFrom: moment(
              element.homeQuarantineStart,
              "YYYY.MM.DD HH:mm:ss"
            ).toISOString(),
            timeTo: element.homeQuarantineEnd
              ? moment(
                  element.homeQuarantineEnd,
                  "YYYY.MM.DD HH:mm:ss"
                ).toISOString()
              : null
          });
        }
        delete element.status;
        delete element.statusText;
        delete element.genderText;
        delete element.date;
        delete element.address;
        delete element.geocodedAddress;
        delete element.homeQuarantineStart;
        delete element.homeQuarantineEnd;
      });

      try {
        let params = { type: "default" };
        if (this.tab === 1) {
          params = { type: "hq" };
        }
        await api.bulkInsert(this.data, params);
        if (this.tab === 1) {
          await this.updateDate();
        }

        this.file = undefined;
        this.data = [];
        this.$refs.form.resetValidation();

        this.success(this.$t("The upload was successful!"));
      } catch (ex) {
        this.error(ex);
      }
      this.isUploading = false;
    },

    async updateDate() {
      let fromDate = new Date();
      fromDate.setHours(0, 0, 0, 0);
      let lhq = await api.getLatestHomeQuarantineDate();
      if (lhq.data && lhq.data.latestHomeQuarantineDate) {
        fromDate = moment(lhq.data.latestHomeQuarantineDate);
        fromDate.add(1, "days");
      }
      this.date = moment(fromDate).format("YYYY-MM-DD");
    },

    getValidityColor(validity) {
      switch (validity) {
        case 2:
          return "red";
        case 1:
          return "orange";
        default:
          return;
      }
    },
    upsertWarningDates(item) {
      let lastLoadDate = moment().add(1, 'days');
      let w = this.validityWarnings.find((x) => x.nr === item.id);

      let dates = [];
      let details = {};
      // check future start dates
      if (moment(item.date, ['YYYY.MM.DD']) > lastLoadDate) {
        let message = 'Status start date is in future';
        dates.push(message);
      }
      if (moment(item.homeQuarantineStart, ['YYYY.MM.DD']) > lastLoadDate) {
        let message = 'Home quarantine start date is in future';
        dates.push(message);
      }
      // check home quarantine end date
      if (item.homeQuarantineStart && item.homeQuarantineEnd) {
        let diff = moment(item.homeQuarantineEnd, ['YYYY.MM.DD']).diff(
          moment(item.homeQuarantineStart, ['YYYY.MM.DD']),
          'days'
        );
        if (diff > 60 || diff < 0) {
          let message =
            'Home quarantine duration ' + (diff > 60 ? 'is too long' : 'is not applicable');
          dates.push(message);
        }
      }
      // update validityWarnings
      if (w) {
        delete w.dates;
        delete w.details;
        if (dates) {
          w.dates = dates;
        }
        if (details) {
          w.details = details;
        }
      } else {
        let warning = { nr: item.id };
        if (dates) {
          warning.dates = dates;
        }
        if (details) {
          warning.details = details;
        }
        this.validityWarnings.push({ warning });
      }
    },

    upsertWarningDbDuplicates(index, duplicates) {
      let w = this.validityWarnings.find(x => x.nr === index);
      if (w) {
        if (!w.duplicates) {
          w.duplicates = [];
        }
        w.duplicates = w.duplicates.filter(x => x.type !== "db");
        w.duplicates = w.duplicates.concat(duplicates);
        if (!w.duplicates.length) {
          w.duplicates = undefined;
        }
      } else {
        this.validityWarnings.push({
          nr: index,
          duplicates: duplicates.length ? duplicates : undefined
        });
      }
    },
    getWarningMessage(index) {
      let msg = "";
      let w = this.validityWarnings.find(x => x.nr === index);
      if (w) {
        if (w.duplicates) {
          msg = `<b>${this.$t('Warning')}!</b><br>`;
          if (w.duplicates.length) {
            const dbDuplicates = w.duplicates.filter(x => x.type === "db");
            if (dbDuplicates.length) {
              msg +=
                `${this.$t("The database contains entries similar to the current entry")}:<br>`;
              msg = this.setWarningDuplicateItem(msg, dbDuplicates);
            }

            const ownDuplicates = w.duplicates.filter(x => x.type === "own");

            if (ownDuplicates.length) {
              msg +=
                `${this.$t('The uploaded data contains entries similar to the current entry')}:<br>`;
              msg = this.setWarningDuplicateItem(msg, ownDuplicates);
            }
          }
        }
        if (w.dates) {
          for (let message of w.dates) {
            msg += `<b>${this.$t(message)}<b><br>`;
          }
        }
        if (w.msg) {
          msg += "<b>" + w.msg + "</b><br>";
        }
      }

      return msg;
    },
    setWarningDuplicateItem(msg, duplicates) {
      const sourceText = source => {
        switch (source) {
          case "asura":
            return "Asura";
          case "excel":
            return "Excel import";
          case "manual":
            return this.$t("manual recording");
          default:
            return this.$t("unknown");
        }
      };
      for (let duplicate of duplicates) {
        msg +=
          "- " +
          (duplicate.azon ? duplicate.azon : this.$t("unknown")) +
          ` (${this.$t('Gender')}: ` +
          (this.genderText(duplicate.gender)
            ? this.genderText(duplicate.gender)
            : this.$t("unknown")) +
          `, ${this.$t('Age')}: ` +
          (duplicate.age ? duplicate.age : this.$t("unknown")) +
          `, ${this.$t('Address')}: ` +
          (duplicate.address ? duplicate.address : this.$t("unknown")) +
          `, ${this.$t('Mobile number')}: ` +
          (duplicate.phoneNumber ? duplicate.phoneNumber : this.$t("unknown")) +
          (duplicate.sources && duplicate.sources.length
            ? `, ${this.$t('Source')}: ` + duplicate.sources.map(sourceText).join(", ")
            : "") +
          ")<br>";
      }
      return msg;
    },
    updateItemValidity(id) {
      let item = this.data.find(x => x.id === id);
      if (!item) {
        return;
      }
      if (item.validity === 2) {
        item.validityMessage =
          `<b>${this.$t('Error')}!</b><br>${this.$t('ID, status and address are required!')}<br>`;
        item.validityMessage += this.getWarningMessage(id) || "";
      } else {
        item.validityMessage = this.getWarningMessage(id);
        item.validity = item.validityMessage ? 1 : 0;
      }
    },
    updateConnectedDuplicates(id, duplicates) {
      for (const d of duplicates) {
        if (d.type === "own") {
          let ow = this.validityWarnings.find(x => x.nr === d.id);
          if (ow && ow.duplicates) {
            ow.duplicates = ow.duplicates.filter(x => x.id !== id);
            if (!ow.duplicates.length) {
              ow.duplicates = undefined;
            }
            this.updateItemValidity(ow.nr);
          }
        }
      }
    }
  }
};
</script>
